// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c4396623","455":"4f354a3e"}[chunkId] + ".chunk.js";
};